import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCAPTCHAWrapper = ({ recaptchaRef }) => {
  return (
    <ReCAPTCHA ref={recaptchaRef} size='invisible' sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY} />
  )
};

ReCAPTCHAWrapper.propTypes = {
  recaptchaRef: PropTypes.object.isRequired
};

export default ReCAPTCHAWrapper;